export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7665.786a2595.jpg";